import type { FixedProductInput } from '@weft/types';
import React from 'react';
import { ChargesEditDataGrid } from '../ChargesEditDataGrid';
import { FIXED_CHARGES_EDIT_COLUMNS } from './fixed-charges-edit-table-consts/fixed-charges-edit-columns';

type FixedChargesEditTableProps = {
  fixedProducts: FixedProductInput[];
};

export const FixedChargesEditTable: React.FC<FixedChargesEditTableProps> = ({ fixedProducts }) => {
  return (
    <ChargesEditDataGrid
      columns={FIXED_CHARGES_EDIT_COLUMNS}
      rows={fixedProducts}
      columnHeaderHeight={40}
      rowHeight={66}
      disableColumnMenu
      disableRowSelectionOnClick
      hideFooter
    />
  );
};